import React from 'react'
import { IconArrowRight, IconBuildingSkyscraper } from '@tabler/icons-react'

import { Card } from '@/components/cards/Card'
import { Button } from '@/components/buttons/Button'
import { SPINE_LEAD } from './AgenticInsights.constants'
import { Spine } from './Spine'
import { getOpportunityLabel } from './AgenticInsights.helpers'
import { InsightCardMeta } from './InsightCardMeta'
import { DismissInsightButton } from './DismissInsightButton'

// The Executive sub-tab card: an off-call process/training fix. Same
// goal → obstacle → recommendation spine as the agent card, but the fix is
// aimed at the team (no on-call script), and there's no launch flow — executive
// insights aren't run as real-time experiments. The stat is prevalence (how
// much of decided calls this blocker accounts for), not a conversion lift,
// because operational insights carry no real lift.
export const ExecutiveInsightCard = ({ insight, onOpen, onDismiss }) => {
  const pct = Math.round((insight.pctOfConclusive ?? 0) * 100)

  return (
    <Card clickable className="insight-spine-card" onClick={() => onOpen(insight.id)}>
      {onDismiss && <DismissInsightButton insightId={insight.id} onDismiss={onDismiss} />}
      <div className="insight-spine-card__main">
        <div className="insight-spine-card__tag insight-spine-card__tag--exec">
          <IconBuildingSkyscraper className="icon-svg" />
          Executive
          <InsightCardMeta insight={insight} />
        </div>
        <Spine
          nodes={[
            { kind: 'goal', lead: SPINE_LEAD.GOAL, value: getOpportunityLabel(insight) },
            {
              kind: 'obstacle',
              lead: SPINE_LEAD.OBSTACLE,
              value: insight.conversionReason || insight.title,
            },
            {
              kind: 'fix',
              lead: SPINE_LEAD.FIX_EXEC,
              value: insight.recommendationSummary || insight.recommendation,
              clamp: !insight.recommendationSummary,
            },
          ]}
        />
      </div>
      <div className="insight-spine-card__stat">
        <div className="exec-stat">
          <div className="exec-stat__value">{pct}%</div>
          <div className="exec-stat__label">of decided calls run into this</div>
        </div>
        <Button
          basic
          fullWidth
          className="insight-spine-card__cta"
          icon={<IconArrowRight />}
          alignIcon="right"
          onClick={(event) => {
            event.stopPropagation()
            onOpen(insight.id)
          }}
        >
          Review
        </Button>
      </div>
    </Card>
  )
}
